export const hvdcAcademyDataSources = [
  {
    title: 'HVDC Academy',
    content: `HVDC Academy is an internal platform within HVDC that provides employees with centralized access to a wide range of training materials, courses, and development programs to support their roles and professional growth. It serves as a one‑stop destination for structured learning, helping employees build knowledge, develop skills, and continuously improve through accessible, role‑relevant training content.  The platform is designed to simplify access to HVDC knowledge, support onboarding and competence development, and enable continuous learning across the organization.\n\nContent sourced from Cornerstone, SharePoint, and xECM, the platform ensures access to reliable, up-to-date knowledge and training resources - helping employees enhance skills, drive performance, and support long-term growth within the organization.`,
    sourceSystem: null,
    prompts: [
      'Search the onboarding materials related to safety',
      'Locate the training where I can learn how to use the Adonis tool',
      'Generate a multiple-choice assessment with answers from HVDC safety training materials',
      'Summarize the key learning objectives from safety training in 100 words',
      'Create a bullet-point summary of the steps from process management and governance training',
      'Create a draft of the 10-slide presentation about the document lifecycle. Include necessary training material links and the proposition of the slide layouts'
    ],
    datasourcelink: [
      {
        sourceTitle: 'xECM',
        sourceLink:
          'https://xecm.hitachienergy.com/otcs/llisapi.dll?func=ll&objId=278148650&objAction=browse&viewType=1'
      },
      {
        sourceTitle: 'SharePoint',
        sourceLink: 'https://hitachipowergrids.sharepoint.com/sites/HVDCInternalTrainingPortal'
      },
      {
        sourceTitle: 'MyLearning (Cornerstone) trainings',
        sourceLink:
          'https://hitachipowergrids.sharepoint.com/sites/HVDCInternalTrainingPortal/SitePages/HVDC-Internal-Training-Catalogue(1).aspx'
      }
    ]
  }
]
